import { apiUrls, httpClient as axiosInstance } from "@/src/api"
import type { UserRole } from "@/src/features/internalUsers/constants"
import type { UserType, WorkspaceInfo } from "@/src/auth/types"

export type WorkspaceMeResponse = {
    workspaceId: string
    userId: string
    role: UserRole
    permissions: string[]
}

type WorkspaceMeApiResponse = {
    data?: WorkspaceMeResponse
}

export async function getWorkspaceMe(workspaceId: string): Promise<WorkspaceMeResponse | null> {
    try {
        const response = await axiosInstance.get<WorkspaceMeApiResponse>(apiUrls.WORKSPACE_ME(workspaceId))
        return response.data?.data ?? null
    } catch (error) {
        console.error("Failed to fetch workspace permissions:", error)
        return null
    }
}

export function applyWorkspaceMeToUser(user: UserType, workspaceMe: WorkspaceMeResponse): UserType {
    const activeWorkspace: WorkspaceInfo = {
        ...user.activeWorkspace,
        roleName: workspaceMe.role,
    }

    return {
        ...user,
        role: workspaceMe.role,
        permissions: workspaceMe.permissions,
        activeWorkspace,
        workspaces: user.workspaces.map((workspace) =>
            workspace.id === workspaceMe.workspaceId ? { ...workspace, roleName: workspaceMe.role } : workspace
        ),
    }
}
